export default function(value: string) {
  return value.slice(0, 5);
}
